// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Interior_container__viJvh {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.Interior_text-top-1__6gil- {
  text-align: center;
  letter-spacing: 5px;
  font-size: 16px;
  color: black;
}

.Interior_text-top-2__lt61N {
  text-align: center;
  margin: 0;
  font-size: 45px;
  color: black
}


@media (max-width: 1247px) {
  .Interior_text-top-1__6gil- {
    text-align: center;
    letter-spacing: 3px;
    font-size: 12px;
  }
  
  .Interior_text-top-2__lt61N {
    text-align: center;
    font-size: 25px;
  }
}

@media (min-width: 1248px) and (max-width: 1900px) {
}

@media (min-width: 1901px) {
}`, "",{"version":3,"sources":["webpack://./src/Sections/Interior.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf;AACF;;;AAGA;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;AACA;;AAEA;AACA","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.text-top-1 {\n  text-align: center;\n  letter-spacing: 5px;\n  font-size: 16px;\n  color: black;\n}\n\n.text-top-2 {\n  text-align: center;\n  margin: 0;\n  font-size: 45px;\n  color: black\n}\n\n\n@media (max-width: 1247px) {\n  .text-top-1 {\n    text-align: center;\n    letter-spacing: 3px;\n    font-size: 12px;\n  }\n  \n  .text-top-2 {\n    text-align: center;\n    font-size: 25px;\n  }\n}\n\n@media (min-width: 1248px) and (max-width: 1900px) {\n}\n\n@media (min-width: 1901px) {\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Interior_container__viJvh`,
	"text-top-1": `Interior_text-top-1__6gil-`,
	"text-top-2": `Interior_text-top-2__lt61N`
};
export default ___CSS_LOADER_EXPORT___;
